import { render } from "./DemoView.vue?vue&type=template&id=24623cbe&scoped=true"
import script from "./DemoView.vue?vue&type=script&lang=js"
export * from "./DemoView.vue?vue&type=script&lang=js"

import "./DemoView.vue?vue&type=style&index=0&id=24623cbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24623cbe"]])

export default __exports__